export default __webpack_public_path__ + "static/media/nextArrow.6fbf18d1.svg";